'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imagePath = imagePath;
exports.ownerEvalutionImage = ownerEvalutionImage;
exports.defaultUserIcon = defaultUserIcon;
exports.userImagePath = userImagePath;
exports.fileReadFromInputFile = fileReadFromInputFile;

var _smConst = require('../constants/sm-const');

var _smConst2 = _interopRequireDefault(_smConst);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function imagePath(path) {
  if (global.manifest) {
    return global.manifest[path];
  }

  return '';
}

function ownerEvalutionImage(evaluation) {
  switch (evaluation) {
    case _smConst2.default.OwnerEvaluation.Good:
      return imagePath('common/evaluate_good.png');
    case _smConst2.default.OwnerEvaluation.Average:
      return imagePath('common/evaluate_average.png');
    case _smConst2.default.OwnerEvaluation.Bad:
      return imagePath('common/evaluate_bad.png');
    default:
      return imagePath('common/evaluate_unmeasurable.png');
  }
}

function defaultUserIcon() {
  return 'https://spmkt-test.s3.amazonaws.com/images/api/default_user.png';
}

function userImagePath(user) {
  if (user === null) return defaultUserIcon;
  if (user.deletedAt !== null) return defaultUserIcon;

  return user.profileImage;
}

function fileReadFromInputFile(file, onLoad) {
  if (URL && URL.createObjectURL) {
    onLoad(URL.createObjectURL(file));
  } else {
    var reader = new FileReader();
    reader.onload = function () {
      if (onLoad) {
        onLoad(reader.result);
      }
    };
    reader.readAsDataURL(file);
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/frontend_core/dist/helpers/image.js
// module id = 23
// module chunks = 0